import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody
} from "reactstrap";
import Moment from "react-moment";
import Swal from "sweetalert2";
import CourseStages from "./Stages";
import { drawAasmState } from "../commons/Functions";
import { switchCourseState, duplicateCourseAPI, activatePublicationAPI } from "./Axios";
import CourseButtonTools from "./ButtonTools";

const companyLogoSrc = (key) => {
  if (key === "bice_bank")        return RAILS_ASSET_URL("/images/companies/BANCO_BICE_AZUL.png");
  if (key === "bk")               return RAILS_ASSET_URL("/images/companies/BK_AZUL.png");
  if (key === "bice_investments") return RAILS_ASSET_URL("/images/companies/BICE_INVERSIONES_GRIS.png");
  if (key === "bice_corp")        return RAILS_ASSET_URL("/images/companies/BICE_CORP_AZUL.png");
  return null;
};
const companyLabel = (key) => ({
  bice_bank: "Banco BICE",
  bk: "BK Servicios",
  bice_investments: "BICE Inversiones",
  bice_corp: "BICE Corp"
}[key] || "");


class CoursesHit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hit: this.props.hit
    };
  }

  handleCloseCourse = (state) => {
    const courseId = this.state.hit.id;
    const isClosing = state === "close";
    const title = `¿Estás seguro?`;

    const text = isClosing ? "El proceso se va a cerrar, lo que desactivará la oferta laboral en el portal." :  "El proceso se publicará, lo que activará la oferta laboral en el portal."
    const confirmButtonText = isClosing ? "Sí, cerrar" : "Sí, Publicar"
    const successMessage = isClosing ? "El proceso ha sido cerrado exitosamente!" : "El proceso ha sido Publicado exitosamente!"
    const successTitle = isClosing ? "¡Cerrado!" : "¡Publicado!"
    Swal.fire({
      title,
      text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        const formData = new FormData();
        formData.append("switch_state", state);
        try {
          switchCourseState(courseId, formData, (response) => {
            if (response.status === 201) {
              Swal.fire(successTitle, successMessage, "success");
              this.updateHit(response.data);
            } else if (response.status === 403) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "No tienes los permisos suficientes para realizar esta acción!",
              });
            }
          });
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Hubo un error, vuelve a intentarlo!",
          });
        }
      }
    });
  };
  handleDuplicateCourse = async () => {
    const courseId = this.state.hit.id;
    const text = "Esta publicación se duplicará y se creará como borrador con el subfijo '(Copia)'. Debes editar antes de poder publicar";

    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Duplicar",
        cancelButtonText: "Cancelar"
      });

      if (!result.isConfirmed) return;

      const response = await duplicateCourseAPI(courseId);

      if (response?.status === 201) {
        Swal.fire("¡Duplicado!", "El proceso ha sido duplicado exitosamente!", "success");
        this.props.addCourseToHits(response.data);
      } else if (response?.status === 403) {
        Swal.fire("Oops...", "No tienes los permisos suficientes para realizar esta acción!", "error");
      } else {
        Swal.fire("Oops...", "Hubo un error desconocido. Vuelve a intentarlo!", "error");
      }
    } catch (error) {
      Swal.fire("Oops...", `Hubo un error: ${error.response?.data?.message || "Vuelve a intentarlo"}`, "error");
    }
  };

  handleActivatePublication = () => {
    const minisiteId = this.state.hit?.minisite_publication?.id;
    if (!minisiteId) {
      Swal.fire("Error", "No se encontró la publicación del minisite", "error");
      return;
    }

    Swal.fire({
      title: "¿Estás seguro?",
      text: "La publicación se activará y será visible en el portal público.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, Activar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        activatePublicationAPI(minisiteId, (response) => {
          if (response.status === 200 || response.status === 201) {
            Swal.fire("¡Activado!", "La publicación ha sido activada exitosamente!", "success");
            // Response now contains course.info_as_json, so we need to extract minisitePublication from it
            const courseData = response.data;
            const minisitePublication = courseData?.minisitePublication || courseData?.minisite_publication;

            // Update the hit with the new state
            const updatedHit = {
              ...this.state.hit,
              minisite_publication: {
                ...this.state.hit.minisite_publication,
                aasm_state: minisitePublication?.aasmState || minisitePublication?.aasm_state || "active"
              }
            };
            this.updateHit(updatedHit);
          } else if (response.status === 403) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data || "No tienes los permisos suficientes para realizar esta acción!",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data || "Hubo un error, vuelve a intentarlo!",
            });
          }
        });
      }
    });
  };



  updateHit = (hit) => {
    this.setState({ hit });
  };

  render() {
    const { hit } = this.state;
    const { currentUserRole } = this.props;

    const companyKey =
      hit?.minisite_publication?.requesting_company ||
      hit?.trabajando_publication?.requesting_company;
    const companyLogo = companyKey && companyLogoSrc(companyKey);
    const companyTitle = companyLabel(companyKey);



    return (
      <Card id={`list-card-${hit.id}`} className="mb-3 publication-list-item job-card material-shadow">
        <CardBody>
          <div className="d-flex justify-content-between flex-wrap">
            <div className="flex-grow-1 pr-md-3 col-lg-6 col-md-12 p-0">
              <h2 className="h5 mb-2 fw-bold d-flex align-items-start gap-2">
                <span className="flex-grow-1">
                  {hit.title}&nbsp;
                  <small>{drawAasmState(hit.aasm_state)}</small>
                  {hit?.trabajando_publication?.id && (
                    <img
                      src={
                        hit.trabajando_publication?.aasm_state === "active"
                          ? RAILS_ASSET_URL("/images/trabajando_active.png")
                          : hit.trabajando_publication?.aasm_state === "in_draft"
                            ? RAILS_ASSET_URL("/images/trabajando_inactive.png")
                            : RAILS_ASSET_URL("/images/trabajando_deactive.png")
                      }
                      alt="Trabajando"
                      title={
                        hit.trabajando_publication?.aasm_state === "active"
                          ? "Trabajando Activo"
                          : hit.trabajando_publication?.aasm_state === "in_draft"
                            ? "Trabajando Borrador"
                            : "Trabajando Inactivo"
                      }
                      className="trabajando-icon ms-1"
                    />
                  )}
                </span>

                {companyLogo && (
                  <img
                    src={companyLogo}
                    alt={companyTitle}
                    title={companyTitle}
                    height="30"
                    className="d-block"
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                  />
                )}
              </h2>

              <div className="media flex-wrap">
                <div className="media-body">
                  <ul className="fa-ul list-unstyled mb-0 ms-4 publication-detail-list">
                    <li>
                      <span className="fa-li">
                        <i
                          aria-hidden="true"
                          className="fas fa-hashtag"
                          title="ID"
                        ></i>
                      </span>
                      ID: {hit.id}
                    </li>
                    <li>
                      <span className="fa-li">
                        <i
                          aria-hidden="true"
                          className="far fa-calendar-alt"
                          title="Fecha de Publicación"
                        ></i>
                      </span>
                      <Moment format="DD/MM/YYYY">{hit.created_at}</Moment>{" "}
                      {drawAasmState(hit.minisite_publication.aasm_state)}
                    </li>
                    <li>
                      <span className="fa-li">
                        <i
                          aria-hidden="true"
                          className="far fa-calendar-times"
                          title="Fecha de Expiración"
                        ></i>
                      </span>
                      <Moment format="DD/MM/YYYY">
                        {hit?.minisite_publication?.desactivate_at}
                      </Moment>{" "}
                    </li>
                    <li>
                      <span className="fa-li">
                        <i
                          aria-hidden="true"
                          className="fas fa-business-time"
                          title="Jornada, Horarios y/o Turnos"
                        ></i>
                      </span>
                      {I18n.t(
                        `activerecord.enums.publication/base.preferred_schedules.${hit.minisite_publication.preferred_schedule}`
                      )}
                    </li>
                    <li>
                      <span className="fa-li">
                        <i
                          aria-hidden="true"
                          className="fas fa-map-marker-alt"
                          title="Ubicación"
                        ></i>
                      </span>
                      {hit.minisite_publication.commune.name},{" "}
                      {hit.minisite_publication.region.name}.{" "}
                      {hit.minisite_publication.country.name}.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex-fill p-0 col-lg-4 col-md-12 p-md-0 text-center d-flex flex-column flex-sm-row flex-md-column flex-lg-column align-items-center justify-content-center">
              <CourseStages
                postulationsCount={
                  (hit?.minisite_publication?.postulations_count ?? 0) +
                  (hit?.trabajando_publication?.postulations_count ?? 0)
                }
              />
            </div>

            <div className="flex-lg-shrink flex-fill p-0 text-right d-flex flex-column flex-sm-row flex-md-row flex-lg-column align-items-center justify-content-center">
              <div className="company_tools text-center align-self-lg-end mt-3 mt-sm-0">
                <CourseButtonTools
                  handleCloseCourse={this.handleCloseCourse}
                  handleActivatePublication={this.handleActivatePublication}
                  handleDuplicateCourse={this.handleDuplicateCourse}
                  course={hit}
                  currentUserRole={currentUserRole}
                  showHeadAccessButton={false}
                />
              </div>

              <Button
                size="sm"
                color="primary"
                className="my-3 align-self-lg-end"
                href={`/courses/${hit.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver Postulaciones
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }
}

export default CoursesHit;
